import * as types from '../constants/actionTypes';

export const fetchAnalyticsDashboardRequest = (params) => ({
  type: types.FETCH_ANALYTICS_DASHBOARD_REQUEST,
  payload: params,
});

export const fetchAnalyticsDashboardSuccess = (data) => ({
  type: types.FETCH_ANALYTICS_DASHBOARD_SUCCESS,
  payload: data,
});

export const fetchAnalyticsDashboardFailure = (error) => ({
  type: types.FETCH_ANALYTICS_DASHBOARD_FAILURE,
  payload: error,
});

export const fetchAnalyticsVendorProductsRequest = (params) => ({
  type: types.FETCH_ANALYTICS_VENDOR_PRODUCTS_REQUEST,
  payload: params,
});

export const fetchAnalyticsVendorProductsSuccess = (data) => ({
  type: types.FETCH_ANALYTICS_VENDOR_PRODUCTS_SUCCESS,
  payload: data,
});

export const fetchAnalyticsVendorProductsFailure = (error) => ({
  type: types.FETCH_ANALYTICS_VENDOR_PRODUCTS_FAILURE,
  payload: error,
});

export const setAnalyticsFilters = (filters) => ({
  type: types.SET_ANALYTICS_FILTERS,
  payload: filters,
});
